import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IPhamViBan } from "../../../model/respone/category/IPhamViBan";
import { IPhongHoc } from "../../../model/respone/category/IPhongHoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhongHocActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IPhongHoc[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IPhongHoc | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SHOW_SUBJECT_MODAL: {} as IPhongHoc | undefined,
  CLOSE_SUBJECT_MODAL: undefined,

  SHOW_BUSY_MODAL: {} as IPhamViBan | undefined,
  CLOSE_BUSY_MODAL: undefined,

  SAVE_START: {} as IPhongHoc,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: {} as IIdsRequest,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",

  CHANGE_COSO_FILTER: 0,
  CHANGE_SELECTED_IDS: {} as number[],

  SHOW_PHONG_HOC_TRONG_KY_MODAL: {} as IPhongHoc | undefined,
  CLOSE_PHONG_HOC_TRONG_KY_MODAL: undefined,
};
export const ePhongHocActionIds = generateActionTypeIds(
  ePhongHocActionsObj,
  "PHONG_HOC"
);
export type IPhongHocActionTypes = IGenericActionType<
  typeof ePhongHocActionsObj,
  "PHONG_HOC"
>;
